



































































































import { CondicaoDaRegraDeInadimplencia, FormaDePagamento, RegraDeInadimplencia } from "@/models"
import { TipoDeOperacao } from "@/models/Recurso"
import { dateToPtBrFormat } from "@/shareds/date/date-utils"
import { montarOperacaoDeRecurso } from "@/shareds/permissoes-shareds"
import { obrigatorio } from "@/shareds/regras-de-form"
import UserLoginStore from "@/store/vuex/authentication/UserLoginStore"
import { SaveRegraDeInadimplenciaUseCase } from "@/usecases/titulos/SaveRegraDeInadimplenciaUseCase"
import Vue from "vue"
import Component from "vue-class-component"
import { Ref } from "vue-property-decorator"
import SeletorDeGruposEconomicos from "../loja/SeletorDeGruposEconomicos.vue"
import AlertModule from "@/store/vuex/aplicacao/AlertModule"

@Component({
	components: {
		SeletorDeGruposEconomicos,
	},
})
export default class DialogoDeEdicaoDeRegraDeInadimplencia extends Vue {
	@Ref() form!: HTMLFormElement

	mostra = false
	salvando = false
	regra: RegraDeInadimplencia | null = null
	criandoRegra = false
	chaveDoSeletorDeGrupos = 0
	mostrarAdicaoDeTipoDeCliente = false
	obrigatorio = obrigatorio
	saveRegraDeInadimplenciaUseCase = new SaveRegraDeInadimplenciaUseCase()
	dateToPtBrFormat = dateToPtBrFormat

	condicoes: CondicaoDaRegraDeInadimplencia[] = [
		{
			id: '',
			regraDeInadimplencia: '',
			tipoDeGatilho: 'Dias de vencimento',
			operadorCondicao: '≥',
			valor: '0',
		},
	]

	opcoesDeCampos = [
		'Dias de vencimento',
	]

	opcoesDeFormaDePagamento: FormaDePagamento[] = [
		'Cartão',
		'Dinheiro',
		'Voucher',
		'Crediário',
		'TEF Crédito',
		'TEF Débito',
		'TEF Pix',
		'Link',
		'Outros',
		'Cheque',
		'Permuta',
	]

	opcoesDeOperadores = ['≥']

	async salvar(regra: RegraDeInadimplencia | null, ativar: boolean){
		if (!regra) return

		if (!this.validarCamposObrigatorios(regra)) {
			return
		}

		try {
			this.salvando = true

			const regraParaEnviar = {
				...regra,
				ativa: ativar === false ? false : regra.ativa,
				condicaoDaRegraDeInadimplencias: [...this.condicoes].map((condicao) => ({
					tipoDeGatilho: condicao.tipoDeGatilho,
					operadorCondicao: condicao.operadorCondicao,
					valor: condicao.valor,
				})),
			}

			if (regra.id === '') {
				const regraSalva = await this.saveRegraDeInadimplenciaUseCase.criarRegraDeInadimplencia(regraParaEnviar as RegraDeInadimplencia)

				this.$emit('incluirRegraNova', regraSalva)
				AlertModule.setSuccess('Regra criada com sucesso!')
			} else {
				const regraSalva = await this.saveRegraDeInadimplenciaUseCase.atualizarRegraDeInadimplencia(regraParaEnviar as RegraDeInadimplencia)

				this.$emit('atualizarRegraExistente', regraSalva)
				AlertModule.setSuccess('Regra atualizada com sucesso!')
			}

			this.esconder()
		} catch(error: any) {
			AlertModule.setError(error)
		} finally {
			this.salvando = false
		}
		
	}

	mostrar(regra: RegraDeInadimplencia | null, criarRegra: boolean) {
		if (!regra) return
		this.regra =  JSON.parse(JSON.stringify(regra))
		this.mostra = true
		this.criandoRegra = criarRegra
		this.chaveDoSeletorDeGrupos++

		if (criarRegra || regra.id === '') {
			this.resetarParaValoresPadrao()
		} else {
			this.carregarDadosSalvos()
		}
	}

	get idsDosGruposEconomicosDaRegra(): string[] {
		return this.regra?.gruposEconomicos?.map(grupoEconomico => grupoEconomico.id) || []
	}

	private resetarParaValoresPadrao() {
		this.condicoes = [
			{
				id: '',
				regraDeInadimplencia: '',
				tipoDeGatilho: 'Dias de vencimento',
				operadorCondicao: '≥',
				valor: '0',
			},
		]
	}

	private carregarDadosSalvos() {
		if (!this.regra) return
		
		if (this.regra.condicaoDaRegraDeInadimplencias && this.regra.condicaoDaRegraDeInadimplencias.length > 0) {
			this.condicoes =  JSON.parse(JSON.stringify(this.regra.condicaoDaRegraDeInadimplencias))
		}
	}

	esconder() {
		this.regra = null
		this.mostra = false
		
		this.resetarParaValoresPadrao()
	}

	podeRealizarOperacao(operacao: TipoDeOperacao) {
		return UserLoginStore.temAutorizacao(montarOperacaoDeRecurso(operacao, 'regras-de-inadimplencia'))
	}

	get podeAlterarRegra() {
		return this.podeRealizarOperacao('alterar')
	}

	valorPositivo = (val: number) => {
		return val >= 0;
	}

	validarCamposObrigatorios(regra: RegraDeInadimplencia): boolean {
		if (!regra.nome) {
			AlertModule.setError("O nome da regra é obrigatório")
			return false
		}

		if (!regra.gruposEconomicos || regra.gruposEconomicos.length === 0) {
			AlertModule.setError("É necessário vincular pelo menos um grupo econômico")
			return false
		}

		if (!this.condicoes || this.condicoes.length === 0) {
			AlertModule.setError("É necessário configurar pelo menos uma regra de aplicação")
			return false
		}

		for (const condicao of this.condicoes) {
			if (!condicao.tipoDeGatilho) {
				AlertModule.setError("O tipo de gatilho é obrigatório para todas as regras")
				return false
			}
			if (!condicao.operadorCondicao) {
				AlertModule.setError("O operador de condição é obrigatório para todas as regras")
				return false
			}
			if (!condicao.valor) {
				AlertModule.setError("O valor é obrigatório para todas as regras")
				return false
			}
		}

		return true
	}
	
}
